var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tiptap-vuetify',{attrs:{"card-props":{ flat: true },"value":_vm.value,"extensions":_vm.extensions,"placeholder":"Start typing here..."},on:{"input":function($event){return _vm.$emit('fieldChange', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }